import { Pipe, PipeTransform } from '@angular/core';

const matchStringContains = (str: string, rule: any) => {
  if (!str || !rule) {
    return true;
  }
  rule = rule.toLowerCase().replace(/[^a-z\d\s']/gi, '');
  str = str.toLowerCase();
  return new RegExp(
    rule
      .split('')
      .map((c: any) => c.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'))
      .join('.*'),
    'i'
  ).test(str);
};

@Pipe({
    name: 'arrayFilter',
    standalone: false
})
export class ArrayFilterPipe implements PipeTransform {
  transform(results: any[], filter: Object, objKey?: string): any {
    if (!results || !filter) {
      return results;
    }

    const pageString = filter as string;
    if (pageString?.includes('page')) {
      const page = pageString.match(/\d+/g) && pageString.match(/\d+/g)[0];
      if (page) {
        return results.filter((result) => +result['@attributes']['numpage'] === +page);
      }
    }

    return results.filter((result) => {
      if (objKey) {
        return result['@attributes'][objKey] === filter;
      }
      return (
        matchStringContains(result['@attributes']['desan'] || result['@attributes']['desfr'] || result['@attributes']['desal'], filter) ||
        matchStringContains(result['@attributes']['ident'], filter)
      );
    });
  }
}
